import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoadingData: false,
  isLoading: false,
  procedureRooms: [],
  message: null,
  pageSize: "5",
  page: "1",
  totalPages: 1,
};

const resetState = (state, keys) => {
  keys.forEach((key) => {
    state[key] = initialState[key];
  });
};

export const procedureRoomsSlice = createSlice({
  name: "procedureRooms",
  initialState,
  reducers: {
    onLoadingProcedureRooms: (state) => {
      state.isLoadingData = true;
      state.message = null;
    },
    onLoading: (state) => {
      state.isLoading = true;
      state.message = null;
    },
    onLoaded: (state) => {
      state.isLoading = false;
      state.message = null;
    },
    onLoadProcedureRooms: (state, { payload }) => {
      const { page, totalPages, procedureRooms } = payload;
      state.isLoadingData = false;
      state.message = null;
      state.procedureRooms = procedureRooms;
      state.page = page;
      state.totalPages = totalPages;
    },
    onFailedProcedureRooms: (state, { payload }) => {
      state.isLoadingData = false;
      state.message = {
        type: "errorProcedureRooms",
        text: payload,
      };
      resetState(state, ["procedureRooms"]);
    },
    onErrorMessage: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "error",
        text: payload,
      };
    },
    onSuccessMessage: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "success",
        text: payload,
      };
    },
    changePageSize: (state, { payload }) => {
      state.pageSize = payload;
    },
    changePage: (state, { payload }) => {
      state.page = payload;
    },
    onUpdateProcedureRoom: (state, { payload }) => {
      const index = state.procedureRooms.findIndex(
        (procedureRoom) => procedureRoom.id === payload.id
      );
      if (index !== -1) {
        state.procedureRooms[index] = {
          ...payload,
        };
      }
    },
    onAddProcedureRoom: (state, { payload }) => {
      state.procedureRooms.unshift(payload);
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  onLoadingProcedureRooms,
  onLoading,
  onLoaded,
  onLoadProcedureRooms,
  onFailedProcedureRooms,
  onErrorMessage,
  onSuccessMessage,
  changePageSize,
  changePage,
  onUpdateProcedureRoom,
  onAddProcedureRoom,
} = procedureRoomsSlice.actions;
